export type AdPlacement = {
  outbrain: OutbrainProps
  taboola: Record<string, string>
  assertive: Record<string, string>
  style: Record<string, string | number>
}

export const placementConfigs: Record<string, AdPlacement> = {}
